<template>
  <div>
    <el-card>
      <app-breadcrumb :items="items"></app-breadcrumb>
      <div class="loading" v-loading="loading" v-if="fecthItems.length === 0"></div>
      <template v-else>
        <!-- componente modal para ordernar listado -->
        <app-modal-draggable
          v-if="modalDraggable"
          :content="fecthItems"
          :name="'title'"
          :table="'pages'"
        ></app-modal-draggable>
        <!-- componente tabla -->
        <app-table-paginate
          v-if="fecthItems.length > 0"
          :routeEdit="routeEdit"
          :tableQuery="fecthItems"
          :tableColumns="tableColumns"
          :preview="preview"
          :search="true"
          :draggable="true"
          :duplicate="true"
        ></app-table-paginate>
        <el-button type="primary" size="medium" @click="nuevoRegistro()">
          Nuevo
          <i class="el-icon-circle-plus-outline el-icon-right"></i>
        </el-button>
      </template>
    </el-card>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";
import { INTRANET_URL } from "@/common/config";
import { mapGetters } from "vuex";
import { FECTH_TIPO_MENU } from "@/store/actions.type";
import Draggable from "@/components/Dashboard/Modals/draggable";
import breadcrumb from "@//components/_commons/breadcrumb";

export default {
  name: "List",
  components: {
    "app-table-paginate": tablaConPaginador,
    "app-modal-draggable": Draggable,
    "app-breadcrumb": breadcrumb,
  },
  async created() {
    this.preview = INTRANET_URL + "/modulo/";
    this.routeEdit = "/dashboard/" + this.$route.params.db + "/pages/edit/";
    this.$root.$on("delete", (id) => {
      this.eliminarRegistro(id);
    });
    this.$root.$on("duplicate", (e) => this.duplicate(e));
    this.$root.$on("draggable", (e) => this.showDraggable());
    this.$root.$on("closeModal", () => this.closeModal());
  },
  async beforeMount() {
    setTimeout(() => {
      this.getOptionsMenu();
      if (typeof this.userAccessPlugins !== "undefined") {
        this.userAccessPlugins.map((a) => {
          if (a.name === "Páginas") this.access = a.value;
        });
      }
      this.getPages();
    }, 1000);
  },
  data() {
    return {
      items: [
        {
          path: "/dashboard/" + this.$route.params.db,
          label: "Panel",
        },
        {
          path: "",
          label: "Páginas",
        },
      ],
      loading: true,
      tableColumns: [
        {
          prop: "title",
          label: "Título",
        },
        {
          prop: "menu_id",
          label: "Tipo de menú",
        },
        {
          prop: "visible",
          label: "¿Visible?",
          type: "switch",
        },
        {
          prop: "url",
          label: "URL",
        },
      ],
      tableQuery: {},
      searchQuery: "",
      tableData: [],
      routeEdit: null,
      deleterow: false,
      preview: null,
      menu: false,
      modalDraggable: false,
      access: [],
    };
  },
  watch: {
    $route(to) {
      this.loading = true;
      this.routeEdit =
        "/dashboard/" +
        this.$route.params.db +
        "/form/edit/" +
        this.$route.params.table +
        "/";
      this.getPages();
    },
  },
  methods: {
    nuevoRegistro() {
      this.$router.push("/dashboard/" + this.$route.params.db + "/pages/new");
    },
    async getOptionsMenu() {
      this.menu = await this.$store.dispatch(FECTH_TIPO_MENU);
    },
    async getPages() {
      this.tableQuery = [];
      const a = await ApiService.post("dashboard/table", {
        table: "pages",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
      });
      if (a.status === 200 && a.data !== "Algo ha fallado") {
        const menu = await this.$store.dispatch(FECTH_TIPO_MENU);

        await a.data.map((a) => {
          this.access.map((p) => {
            if (a.id == p) {
              menu.map((e) => {
                if (a.menu_id == e.id) {
                  a.menu_id = e.menu;
                }
              });
              this.tableQuery.push(a);
            }
          });
        });
        await this.tableQuery.sort(function (a, b) {
          return a.order_row - b.order_row;
        });
      }
    },
    async eliminarRegistro(id) {
      const a = await ApiService.post("dashboard/delete", {
        table: "pages",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: id,
      });
      if (a.status === 200) {
        this.deleterow = a.data;
        if (this.deleterow == 1) {
          this.$message({
            type: "success",
            message: "Se ha eliminado correctamente",
          });
          this.getPages();
        } else {
          this.$message({
            type: "warning",
            message: this.deleterow,
          });
        }
      }
    },

    async duplicate(e) {
      const title = prompt("Título", e.title);
      const url = prompt("URL", e.url);
      let form = {
        id: e.id,
        title: title,
        menu_id: e.menu_id === "Vertical" ? 1 : 2,
        url: url,
      };

      const a = await ApiService.post("dashboard/duplicate-page", {
        table: "pages",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: form,
        id: this.$route.params.id,
      });
      if (a.data) {
        this.$notify({
          title: "Modificado",
          message: "Se ha duplicado la página con éxito",
          type: "success",
        });
        this.getPages();
      } else {
        this.$notify.error({
          title: "Fallo",
          message: "Ago ha fallodo y no se ha duplicado la página",
        });
      }
    },
    showDraggable() {
      this.modalDraggable = true;
    },
    closeModal() {
      this.modalDraggable = false;
      this.getPages();
    },
  },
  computed: {
    fecthItems() {
      return this.tableQuery;
    },
    ...mapGetters(["userAccessPlugins"]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/pages/list.vue